"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_1 = require("@ethersproject/bignumber");
const ethers_1 = require("ethers");
const lodash_1 = __importDefault(require("lodash"));
const base_1 = require("../base");
const constant_1 = require("../constant");
const util_1 = require("../util");
class VaultModule extends base_1.TectonicSDKModule {
    async getPools() {
        const vault = this.getTectonicVault();
        const poolCounts = (await vault.poolLength()).toNumber();
        const pools = [];
        const vaultRewardRate = await vault.vaultRewardRate();
        const xTonicExRate = await this.getTectonicStakingPool().getExchangeRate();
        const vaultTotalSupply = await vault.totalSupply();
        // const lastRewardBlock = await vault.lastRewardBlock();
        // console.log("lastRewardBlock", lastRewardBlock.toString());
        // console.log("vaultRewardRate", vaultRewardRate.toString());
        // console.log("xTonicExRate", xTonicExRate.toString());
        // console.log("vaultTotalSupply", vaultTotalSupply.toString());
        let apy = bignumber_1.BigNumber.from(0);
        for (let i = 0; i < poolCounts; i++) {
            const rawPoolInfo = await vault.poolInfo(i);
            if (!vaultTotalSupply.eq(bignumber_1.BigNumber.from(0))) {
                apy = vaultRewardRate
                    .mul(rawPoolInfo.multiplier)
                    .mul(xTonicExRate)
                    .mul(constant_1.TectonicConst.BLOCKS_PER_YEAR)
                    .div(vaultTotalSupply);
            }
            pools.push({
                poolId: i,
                multiplier: rawPoolInfo.multiplier,
                lockPeriod: rawPoolInfo.lockPeriod,
                apy: Number(ethers_1.ethers.utils.formatEther(apy)),
                totalStaked: rawPoolInfo.totalStaked,
            });
        }
        return pools;
    }
    async isApproved(walletAddress) {
        const vault = this.getTectonicVault();
        const xTonic = this.getXTonic();
        const allowance = await xTonic.allowance(walletAddress, vault.address);
        return !allowance.eq(bignumber_1.BigNumber.from(0));
    }
    async approve() {
        const vault = this.getTectonicVault();
        const xTonic = this.getXTonic();
        return (0, util_1.wrapSdkTransaction)(xTonic.approve(vault.address, ethers_1.ethers.constants.MaxUint256));
    }
    async getUserStakes(walletAddress) {
        const vault = this.getTectonicVault();
        const userInfo = await vault.getUserInfo(walletAddress);
        const userStakes = [];
        const pools = await this.Vault.getPools();
        let ptr = -1;
        for (const stake of userInfo[2]) {
            ptr++;
            const { amount, poolId, stakeTimestamp, unlockTimestamp, active } = stake;
            if (!active) {
                continue;
            }
            const pool = lodash_1.default.find(pools, { poolId: poolId.toNumber() });
            userStakes.push({
                stakeId: ptr,
                pool,
                amount,
                lockStartDate: new Date(stakeTimestamp.toNumber() * 1000),
                lockEndDate: new Date(unlockTimestamp.toNumber() * 1000),
            });
        }
        return userStakes;
    }
    async deposit(poolId, amount, account) {
        const vault = this.getTectonicVault();
        const allowance = await this.getXTonic().allowance(account, vault.address);
        if (allowance.lt(bignumber_1.BigNumber.from(amount))) {
            const vault = this.getTectonicVault();
            const xTonic = this.getXTonic();
            const tx = await xTonic.approve(vault.address, ethers_1.ethers.constants.MaxUint256);
            await tx.wait();
        }
        return (0, util_1.wrapSdkTransaction)(vault.deposit(poolId, amount));
    }
    async withdraw(stakeId) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.withdraw(stakeId));
    }
    async batchWithdraw(stakeIds) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.batchWithdraw(stakeIds));
    }
    async upgrade(stakeId, newPoodId) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.upgrade(stakeId, newPoodId));
    }
    async batchUpgrade(stakeIds, newPoodIds) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.batchUpgrade(stakeIds, newPoodIds));
    }
    async getPendingTonic(ownerAddress) {
        const vault = this.getTectonicVault();
        return vault.pendingTONIC(ownerAddress);
    }
    async harvest() {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.deposit(0, 0));
    }
    async getAccTokenPerShare(ownerAddress) {
        const vault = this.getTectonicVault();
        return vault.accTokenPerShare();
    }
    getXTonic() {
        return super.getXTonic();
    }
    /**
     * @notice Stake NFTs
     * @param nftContract               Contract address of the NFT collection to stake
     * @param tokenIds                  token Ids of the NFTs to stake
     * @param poolId                    Pool Id of the vault to boost
     */
    async stakeNFTs(nftContract, tokenIds, poolId) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.stakeToVault(nftContract, tokenIds, poolId));
    }
    /**
     * @notice unstake NFTs
     * @param nftContract               Contract address of the NFT collection to unstake
     * @param tokenIds                  token Ids of the NFTs to unstake
     * @param poolId                    Pool Id of the vault to boost
     */
    async unstakeNFTs(nftContract, tokenIds, poolId) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.unStakeFromVault(nftContract, tokenIds, poolId));
    }
    /**
     * @notice replace a user's NFTs in a vault
     * @param nftContract               Contract address of the NFT collection to replace
     * @param unstakeTokenIds           token Ids of the NFTs to unstake
     * @param stakeTokenIds             token Ids of the NFTs to stake
     * @param poolId                    Pool Id of the vault to boost
     */
    async replaceNFTs(nftContract, unstakeTokenIds, stakeTokenIds, poolId) {
        const vault = this.getTectonicVault();
        return (0, util_1.wrapSdkTransaction)(vault.replaceNFTs(nftContract, unstakeTokenIds, stakeTokenIds, poolId));
    }
    /**
     * @notice Get the list of staked NFT collections
     */
    async getUserStakedCollections(ownerAddress) {
        const vault = this.getTectonicVault();
        return vault.getUserCollections(ownerAddress);
    }
    /**
     * @notice Get the list of nft contracts enabled for staking
     */
    async getEnabledNFTCollections() {
        const vault = this.getTectonicVault();
        return vault.getEnabledNFTCollections();
    }
    /**
     * @notice Get the list of staked NFTs by user by collection
     */
    async getUserStakedNFTsByCollection(ownerAddress, nftContract) {
        const vault = this.getTectonicVault();
        return vault.getUserStakedNfts(ownerAddress, nftContract);
    }
    /**
     * @notice Get StakedNftInfo by nft collection by token id
     */
    async getStakedNftInfo(nftContract, tokenId) {
        const vault = this.getTectonicVault();
        const stakedNftInfo = await vault.getStakedNftInfo(nftContract, tokenId);
        const tectonicVaultStakedNftInfo = {
            userAddress: stakedNftInfo[0],
            poolId: stakedNftInfo[1],
            multiplier: stakedNftInfo[2],
        };
        return tectonicVaultStakedNftInfo;
    }
    async getTokenIds(ownerAddress, poolId, nftContract) {
        const vault = this.getTectonicVault();
        let nftContracts = [];
        let tokenIds = [];
        if (nftContract == null) {
            let nftCollections = await vault.getUserCollections(ownerAddress);
            for (const nft of nftCollections) {
                nftContracts.push(nft);
            }
        }
        else {
            nftContracts.push(nftContract);
        }
        for (const nft of nftContracts) {
            let nfts = await vault.getUserStakedNfts(ownerAddress, nft);
            for (const tokenId of nfts) {
                const stakedNftInfo = await vault.getStakedNftInfo(nft, tokenId);
                if (stakedNftInfo[1].eq(poolId)) {
                    tokenIds.push(tokenId);
                }
            }
        }
        return tokenIds;
    }
    /**
     * Get a multiplier of APY when user has NFTs staked
     * @param ownerAddress
     * @param poolId
     */
    async getUserNftBoostMultiplier(ownerAddress, poolId) {
        const vault = this.getTectonicVault();
        const userNftBoostingInfo = await vault.getUserNftBoostingInfo(ownerAddress, poolId);
        console.log('userNftBoostingInfo', userNftBoostingInfo.toString());
        const totalNFTMultiplier = userNftBoostingInfo[2];
        console.log('totalNFTMultiplier', totalNFTMultiplier.toString());
        const effectiveMultiplier = await vault.getEffectiveNftMultiplier(totalNFTMultiplier);
        console.log('effectiveMultiplier', effectiveMultiplier.toString());
        // NFT multiplier precision = 10_000
        return Number(1 + Number(effectiveMultiplier) / 10000);
    }
    async getEstimatedUserNftBoostMultiplier(nftContract, ownerAddress, stakeTokenIds, unstakeTokenIds, poolId) {
        const vault = this.getTectonicVault();
        const userNftBoostingInfo = await vault.getUserNftBoostingInfo(ownerAddress, poolId);
        console.log('userNftBoostingInfo', userNftBoostingInfo.toString());
        const totalNFTMultiplier = userNftBoostingInfo[2];
        console.log('totalNFTMultiplier', totalNFTMultiplier.toString());
        const effectiveMultiplier = await vault.getEstimatedEffectiveNftMultiplier(totalNFTMultiplier, nftContract, unstakeTokenIds, stakeTokenIds);
        console.log('effectiveMultiplier', effectiveMultiplier.toString());
        // NFT multiplier precision = 10_000
        return Number(1 + Number(effectiveMultiplier) / 10000);
    }
    async getMaxEstimatedNftBoostMultiplier(nftContract, tokenIds) {
        const vault = this.getTectonicVault();
        const multiplierRegistryAddress = await vault.multiplierRegistries(nftContract);
        const multiplierRegistry = (await this.getContractByAddressAndType(multiplierRegistryAddress, 'MultiplierRegistry'));
        const multipliers = await multiplierRegistry.getMultipliers(tokenIds);
        console.log('multipliers: ', multipliers);
        const maxNftCountInBigNumber = await vault.nftLimitPerUserPerVault();
        const maxNftCount = maxNftCountInBigNumber.toNumber();
        console.log('maxNftCount: ', maxNftCount);
        console.log('tokenIds.length: ', tokenIds.length);
        if (maxNftCount < tokenIds.length) {
            return 1;
        }
        let totalMultiplier = bignumber_1.BigNumber.from(0);
        for (let i = 0; i < tokenIds.length; i++) {
            totalMultiplier = totalMultiplier.add(multipliers[i]);
            console.log('totalMultiplier i: ', totalMultiplier.toString());
        }
        console.log('totalMultiplier: ', totalMultiplier.toString());
        const maxMultiplier = await vault.maxTotalNftMultiplier();
        console.log('maxMultiplier: ', maxMultiplier.toString());
        if (totalMultiplier.gt(maxMultiplier)) {
            totalMultiplier = maxMultiplier;
        }
        console.log('totalMultiplier: ', totalMultiplier.toString());
        // NFT multiplier precision = 10_000
        return Number(1 + Number(totalMultiplier) / 10000);
    }
    async getNftMultiplier(nftContract, tokenId) {
        const vault = this.getTectonicVault();
        const multiplierRegistryAddress = await vault.multiplierRegistries(nftContract);
        const multiplierRegistry = (await this.getContractByAddressAndType(multiplierRegistryAddress, 'MultiplierRegistry'));
        const multiplier = await multiplierRegistry.getMultiplier(tokenId);
        // NFT multiplier precision = 10_000
        return Number(multiplier) / 10000;
    }
    async getMaxNftPerVault() {
        const vault = this.getTectonicVault();
        const maxNftPerVaultInBigNumber = await vault.nftLimitPerUserPerVault();
        return maxNftPerVaultInBigNumber.toNumber();
    }
}
exports.default = VaultModule;
//# sourceMappingURL=vault.js.map